import { Source } from '@wove/api/types'
import SourceRow from '@src/Pages/UploadPage/SourceRow'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  Input,
} from '@wove/web-ui'
import { useState } from 'react'
import { FileText, Search, SlidersHorizontal } from 'lucide-react'

interface SourceTableProps {
  sources: Source[]
}

const SourceTable = ({ sources }: SourceTableProps) => {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredSources = sources.filter((source) =>
    source.name.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  return (
    // <div className="mt-[18px]">
    //   <div className="flex text-xs font-bold leading-[18px] uppercase h-[46px] items-stretch text-grey-text">
    //     <div className="w-[66px] flex-shrink-0" />
    //     <div className="flex-[2_1_0px] flex items-center cursor-pointer">Name</div>
    //     <div className="flex-[1_1_0px] flex items-center cursor-pointer">Rates</div>
    //     <div className="flex-[1_1_0px] flex items-center cursor-pointer">Type</div>
    //     <div className="flex-[1_1_0px] flex items-center cursor-pointer">Tags</div>
    //     <div className="flex-[1_1_0px] flex items-center cursor-pointer">Size</div>
    //     <div className="flex-[1_1_0px] flex items-center cursor-pointer">Uploaded</div>
    //     {/*<div className="flex-[1_1_0px] flex items-center cursor-pointer">Added By</div>*/}
    //     <div className="w-12 flex-shrink-0" />
    //   </div>
    //   {sources.map((source) => (
    //     <SourceRow source={source} key={source.id} />
    //   ))}
    // </div>
    <Card className="mt-6">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>All Files</CardTitle>
        <div className="flex items-center gap-2">
          <div className="relative">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Search files..."
              className="w-[120px] pl-8 sm:w-[200px] md:w-[300px]"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <Button variant="outline" size="icon">
            <SlidersHorizontal className="h-4 w-4" />
            <span className="sr-only">Filter</span>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Size</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Upload Date</TableHead>
                <TableHead className="w-[80px]">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredSources.length > 0 ? (
                filteredSources.map((file) => <SourceRow file={file} key={file.id} />)
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className="h-24 text-center">
                    <div className="flex flex-col items-center justify-center text-muted-foreground">
                      <FileText className="h-8 w-8 mb-2" />
                      <p>No files found</p>
                      <p className="text-xs">Upload files using the form above</p>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  )
}

export default SourceTable
